import { Stack } from "@mui/material";
import { useState } from "react";
import { useLoyaltiesEventRecordsInfiniteQuery } from "Api/Queries/Loyalty/useLoyaltiesEventRecordsQuery";
import { LoyaltyPeriodSelector } from "Components/Loyalty/Shared/PeriodSelect/LoyaltyPeriodSelector";
import { Rewards } from "Components/Loyalty/Shared/Rewards/Rewards";
import type { RewardEntry } from "Components/Loyalty/Shared/Rewards/types";
import type { LoyaltyPointType } from "Infrastructure/Api/Api";
import { Resources, useResource } from "Translations/Resources";

const RESOURCES = Resources.Pages.Content.Loyalty.Rewards;
const EVENTS_RESOURCES = Resources.Pages.Content.Loyalty.Events;

type Props = {
  pointType: LoyaltyPointType;
  pointsLabel: string;
};

export const LoyaltyRewardsSection = ({ pointType, pointsLabel }: Props) => {
  const [settlementPeriodId, setSettlementPeriodId] = useState<number>(); // undefined = current month
  const { t } = useResource();

  const {
    data,
    isLoading,
    isError,
    hasNextPage,
    isFetchingNextPage,
    fetchNextPage,
    isPlaceholderData,
  } = useLoyaltiesEventRecordsInfiniteQuery({
    limit: 20,
    nextPageLimit: 20,
    pointType,
    settlementPeriodId,
  });

  const items: Array<RewardEntry> | undefined = data?.pages.flatMap(
    ({ items }) =>
      (items ?? []).map(({ dateCreated, eventCode, points }) => ({
        date: new Date(dateCreated),
        activity: t(EVENTS_RESOURCES[eventCode].title),
        points,
      })),
  );

  return (
    <Stack gap={4}>
      <LoyaltyPeriodSelector onPeriodChange={setSettlementPeriodId} />
      <Rewards
        title={t(RESOURCES.Title)}
        pointsLabel={pointsLabel}
        items={items}
        isLoading={isLoading}
        isError={isError}
        hasNextPage={(hasNextPage ?? false) && !isPlaceholderData}
        isFetchingNextPage={isFetchingNextPage}
        fetchNextPage={fetchNextPage}
      />
    </Stack>
  );
};
